import React from "react";
import {Button, message} from 'antd';
import getSize from "../../../utils/getSize";
import NHFetch from "../../../utils/NHFetch";
import NHTable from '../../common/NHTable';
import {NHConfirm} from '../../common/NHModal';
import NHContainerFrame from '../../common/NHContainerFrame';
import EditForm from './EditForm.js';
import css from './index.css';
import {hasAuth} from "../../../utils/NHCore";

const basicUrl = "/whgcdx/dtzbwh/";

/**
 * 地图坐标维护页面
 * @author yangqizhi
 */
class Dtzbwh extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formInitData: {},
            updatePkid: '',  // 要修改的地图坐标的pkid，新增时为''
            frameVisibleMap: {
                tableFlag: true,
                addFlag: false,
                updateFlag: false,
            },
            showOperationBtn: false, //是否显示删除操作按钮
        };
    }

    // 设置当前页面显示
    setCurrentPageShow = (showFlagName) => {
        let frameVisibleMap = this.state.frameVisibleMap;
        for (let name in frameVisibleMap) {
            frameVisibleMap[name] = name === showFlagName;
        }
        this.setState({
            frameVisibleMap: frameVisibleMap
        });
    }

    // 关闭内嵌页面
    handleCloseFrame = () => {
        this.setCurrentPageShow('tableFlag');
        this.setState({
            formInitData: {},
            updatePkid: ''
        });
        this.refs.nhTable.filterTableData();
    }

    // 新增页面显示
    handleAddBtnClick = () => {
        this.setCurrentPageShow('addFlag');
    }

    // 新增提交保存
    addSubmitSave = () => {
        this.form.validateFields((err, formData) => {
            if (err) {
                return;
            }
            NHFetch(basicUrl + "insert", "POST", formData).then(resData => {
                if (resData) {
                    message.success("新增成功！");
                    this.setCurrentPageShow('tableFlag');
                    this.refs.nhTable.filterTableData();
                } else {
                    message.error("新增失败！");
                }
            });
        })
    }

    // 修改提交保存
    updateSubmitSave = () => {
        this.form.validateFields((err, formData) => {
            if (err) {
                return;
            }
            formData.pkid = this.state.updatePkid;
            NHFetch(basicUrl + "update", "POST", formData).then(resData => {
                if (resData.data !== 0) {
                    message.success("修改成功！");
                    this.setState({
                        formInitData: {},
                        updatePkid: ''
                    });
                    this.setCurrentPageShow('tableFlag');
                    this.refs.nhTable.filterTableData();
                } else {
                    message.error("修改失败！");
                }
            })
        })
    }

    // 修改页面显示
    handleUpdateBtnClick = (record) => {
        let pkid = record.PKID;
        NHFetch(basicUrl + pkid + '/get', 'GET')
            .then(res => {
                if (res) {
                    this.setState({
                        updatePkid: pkid,
                        formInitData: res.data
                    });
                    this.setCurrentPageShow('updateFlag');
                }
            })
    }

    // 选择行后显示删除操作按钮
    rowSelectionChange = (selectedRowKeys) => {
        if (selectedRowKeys.length) {
            this.setState({
                showOperationBtn: true
            })
        } else {
            this.setState({
                showOperationBtn: false
            })
        }
    }

    // 单行删除
    handleSingleDeleteBtnClick = (record) => {
        NHConfirm("是否确定删除这条数据？", () => {
            let pkid = record.PKID;
            this.handleDelete([pkid]);
        }, "warn");
    }
    // 多行删除
    handleMultiDeleteBtnClick = () => {
        let selectedRowKeys = this.refs.nhTable.state.selectedRowKeys;
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            NHConfirm("是否确定删除选中的多条数据？", () => {
                this.handleDelete(selectedRowKeys);
            }, "warn");

        } else {
            message.warning("请先选择需要删除的数据！");
        }
    }
    // 删除操作
    handleDelete = (pkids) => {
        NHFetch(basicUrl + 'deleteByMulti', 'POST', pkids)
            .then(res => {
                if (res) {
                    if (res.data === 1) {
                        message.success("删除操作成功！");
                    } else {
                        message.success("删除操作失败！");
                    }
                    this.refs.nhTable.filterTableData();
                }
            })
    }

    render() {
        let isAddFlag = this.state.updatePkid === '';
        //列参数
        const columns = [
            {
                title: '序号',
                width: '60px',
                dataIndex: 'ROW_ID'
            }, {
                title: '坐标名称',
                width: '100px',
                dataIndex: 'ZBMC',
            }, {
                title: '经度',
                width: '120px',
                dataIndex: 'JD',
            }, {
                title: '纬度',
                width: '120px',
                dataIndex: 'WD',
            }, {
                title: '坐标备注',
                width: '150px',
                dataIndex: 'BZ',
            }
        ];

        //行内操作
        const action = [
            {
                title: '修改', onClick: this.handleUpdateBtnClick, auth: 'zhxg_yxgl_fwwgl_dtzbwh:update'
            }, {
                title: '删除', onClick: this.handleSingleDeleteBtnClick, auth: 'zhxg_yxgl_fwwgl_dtzbwh:delete'
            }
        ];

        return (
            <div className={css.main_right_content} style={{height: getSize().windowH - 123}}>
                <div className={css.table} style={{display: this.state.frameVisibleMap.tableFlag ? 'block' : 'none'}}>
                    <NHTable ref='nhTable'
                             rowKey={record => record.PKID}
                             sign={"zhxg_yxgl_fwwgl_dtdh_jzwzb_queryPage"}
                             columns={columns}
                             action={action}
                             rowSelectionChange={this.rowSelectionChange}
                    >
                        {
                            hasAuth('zhxg_yxgl_fwwgl_dtzbwh:add') ?
                            <Button type="primary" onClick={this.handleAddBtnClick}>新增</Button>
                                   : undefined
                        }{
                            hasAuth('zhxg_yxgl_fwwgl_dtzbwh:delete') ?
                            <Button type="danger" ghost
                                style={{marginLeft: 10, display: this.state.showOperationBtn ? undefined : 'none'}}
                                onClick={this.handleMultiDeleteBtnClick}>删除</Button>
                           : undefined
                    }
                    </NHTable>
                </div>
                <NHContainerFrame title={isAddFlag ? '新增地图坐标' : '修改地图坐标'}
                                  visible={isAddFlag ? this.state.frameVisibleMap.addFlag : this.state.frameVisibleMap.updateFlag}
                                  contentWidth={24}
                                  onOk={isAddFlag ? this.addSubmitSave : this.updateSubmitSave}
                                  onCancel={this.handleCloseFrame}
                >
                    <EditForm ref={(form) => {
                        this.form = form
                    }} initFormData={this.state.formInitData}/>
                </NHContainerFrame>
            </div>
        );
    }
}

export default Dtzbwh;



// WEBPACK FOOTER //
// ./components/fwwgl/dtzbwh/index.js